import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Contractor } from '@authority-labs/api-interfaces';
import { SelectContractorDialogComponent } from '@check-list/app/modules/contractors/select-contractor-dialog/select-contractor-dialog.component';
import { ContractorDialogService } from '../../dialogs/contractor-dialog';
import { EntitySelectorDialogService } from '../../dialogs/entity-selector-dialog/entity-selector-dialog.service';

@Component({
  selector: 'authority-labs-contractor-selector',
  templateUrl: './contractor-selector.component.html',
  styleUrls: ['./contractor-selector.component.scss']
})
export class ContractorSelectorComponent {
  @Input() readonly = false;
  @Input() printPreview = false;
  @Input() contractor: Contractor = new Contractor();
  @Output() contractorSelect: EventEmitter<Contractor> = new EventEmitter();

  contractors: Contractor[] = [];

  constructor(
    private contractorDialog: ContractorDialogService,
    private entitySelectorDialogService: EntitySelectorDialogService
  ) {}

  selectContractor(): void {
    this.entitySelectorDialogService
      .selectEntity(
        SelectContractorDialogComponent,
        this.contractor ? this.contractor.id : undefined,
        this.readonly
      )
      .afterClosed()
      .subscribe((contractor) => {
        if (contractor) {
          this.contractor = contractor;
          this.contractorSelect.emit(this.contractor);
        }
      });
  }

  newContractor(): void {
    this.contractorDialog
      .create()
      .afterClosed()
      .subscribe((contractor) => {
        if (contractor) {
          this.contractorSelected(contractor);
        }
      });
  }

  editContractor(): void {
    this.contractorDialog
      .edit(this.contractor)
      .afterClosed()
      .subscribe((contractor) => {
        if (contractor) {
          this.contractorSelected(contractor);
        }
      });
  }

  private contractorSelected(contractor: Contractor): void {
    this.contractor = contractor;
    this.contractorSelect.emit(this.contractor);
  }
}
